module.exports = __webpack_public_path__ + "img/bg-login-employer-thumb.c9750e17.jpg";